export default {
      id: "icon--wheelchair-usage",
      viewBox: "0 0 32 30",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wheelchair-usage",
      toString: function () {
        return this.url;
      }
    }